export default [
  {
    "RELEVANCE": "very high",
    "broader": [
      {
        "uri": "http://www.w3.org/2004/02/skos/core#closeMatch"
      }
    ],
    "definition": {
      "de": [
        "gleiche Bedeutung"
      ],
      "en": [
        "same meaning"
      ]
    },
    "notation": [
      "="
    ],
    "prefLabel": {
      "ar": "تطابق تام",
      "be": "дакладная адпаведнасць",
      "be-tarask": "дакладная адпаведнасьць",
      "bn": "হুবুহু মিল",
      "bs": "tačno podudaranje",
      "ca": "equivalència exacta",
      "cs": "přesná shoda",
      "da": "exact match",
      "de": "exakte Übereinstimmung",
      "el": "ακριβής αντιστοιχία",
      "en": "exact match",
      "eo": "ekzakta ekvivalento",
      "es": "equivalencia exacta",
      "et": "täpne vaste",
      "fi": "vastaava käsite",
      "fr": "équivalence exacte",
      "ga": "meaitseáil chruinn",
      "gl": "correspondencia exacta",
      "he": "התאמה מדויקת",
      "hu": "pontos egyezés",
      "id": "sama persis",
      "it": "corrispondenza esatta",
      "ja": "完全一致",
      "lv": "tieša sakritība",
      "mk": "точно совпаѓање",
      "ms": "padanan tepat",
      "ms-arab": "ڤادنن تڤت",
      "nb": "eksakt samsvar",
      "nl": "exacte match",
      "nn": "eksakt samsvar",
      "pl": "dokładne dopasowanie",
      "pt": "correspondência exata",
      "ro": "echivalentul exact",
      "ru": "точное соответствие",
      "sl": "natančno ujemanje",
      "sq": "përputhje e përpiktë",
      "sr": "тачно подударање",
      "sv": "exakt träff",
      "tr": "tam eşleşme",
      "uk": "точна відповідність",
      "ur": "بالکل درست جوڑ",
      "zh": "精確匹配",
      "zh-cn": "精确匹配",
      "zh-hans": "精确匹配",
      "zh-hant": "精確匹配"
    },
    "SHORT": "exact",
    "uri": "http://www.w3.org/2004/02/skos/core#exactMatch"
  },
  {
    "RELEVANCE": "high",
    "broader": [
      {
        "uri": "http://www.w3.org/2004/02/skos/core#mappingRelation"
      }
    ],
    "definition": {
      "de": [
        "in etwa gleiche Bedeutung"
      ],
      "en": [
        "same general idea but not fully identical meaning"
      ]
    },
    "notation": [
      "≈"
    ],
    "prefLabel": {
      "ar": "تطابق قريب",
      "be-tarask": "блізкая адпаведнасьць",
      "ca": "equivalència inexacta",
      "de": "hohe Übereinstimmung",
      "el": "στενή αντιστοιχία",
      "en": "close match",
      "eo": "proksima kongruaĵo",
      "es": "equivalencia inexacta",
      "fi": "lähes vastaava käsite",
      "fr": "quasi-équivalence",
      "he": "התאמה קרובה",
      "hu": "kvázi-egyenértékűség",
      "it": "corrispondenza parziale",
      "ja": "類似一致",
      "mk": "блиско совпаѓање",
      "ms": "padanan dekat",
      "ms-arab": "ڤادنن دکت",
      "nb": "nært samsvar",
      "nl": "nabije match",
      "nn": "nært samsvar",
      "pl": "częściowe dopasowanie",
      "pt": "correspondência próxima",
      "ru": "близкое соответствие",
      "sl": "visoko ujemanje",
      "sr": "блиско поклапање",
      "sv": "nära matchning",
      "tr": "yakın eşleşme",
      "zh-hans": "高度匹配"
    },
    "SHORT": "close",
    "uri": "http://www.w3.org/2004/02/skos/core#closeMatch"
  },
  {
    "RELEVANCE": "medium",
    "broader": [
      {
        "uri": "http://www.w3.org/2004/02/skos/core#mappingRelation"
      }
    ],
    "definition": {
      "de": [
        "umfassendere Bedeutung"
      ],
      "en": [
        "broader meaning"
      ]
    },
    "notation": [
      ">"
    ],
    "prefLabel": {
      "be-tarask": "шырокая адпаведнасьць",
      "ca": "relació llunyana",
      "cs": "širší koncept",
      "de": "allgemeinere Bedeutung",
      "en": "broad match",
      "eo": "malstrikta kongruo",
      "et": "laiem vaste",
      "fi": "vastaava laajempi käsite",
      "he": "התאמה רחבה",
      "hu": "tágabb jelentés",
      "it": "corrispondenza con termine più generico",
      "ja": "広義一致",
      "mk": "пошироко совпаѓање",
      "nb": "bredere samsvar",
      "nl": "brede match",
      "nn": "breitt samsvar",
      "pl": "dopasowanie pojęcia o szerszym znaczeniu",
      "pt-br": "correspondência genérica",
      "ru": "более широкое соответствие",
      "sl": "splošni pomen",
      "sr": "у ширем смислу",
      "sv": "bred träff",
      "uk": "ширша відповідність",
      "vi": "đối sánh rộng",
      "zh-hans": "广泛匹配"
    },
    "related": [
      {
        "uri": "http://www.w3.org/2004/02/skos/core#narrowMatch"
      }
    ],
    "SHORT": "broad",
    "uri": "http://www.w3.org/2004/02/skos/core#broadMatch"
  },
  {
    "RELEVANCE": "medium",
    "broader": [
      {
        "uri": "http://www.w3.org/2004/02/skos/core#mappingRelation"
      }
    ],
    "definition": {
      "en": [
        "more specific meaning"
      ]
    },
    "notation": [
      "<"
    ],
    "prefLabel": {
      "be-tarask": "вузкая адпаведнасьць",
      "ca": "relació estreta",
      "de": "spezifischere Bedeutung",
      "en": "narrow match",
      "eo": "strikta kongruo",
      "et": "kitsam vaste",
      "fi": "vastaava suppeampi käsite",
      "he": "התאמה צרה",
      "hu": "szűkebb jelentés",
      "it": "corrispondenza con termine più specifico",
      "ja": "狭義一致",
      "mk": "потесно совпаѓање",
      "nb": "smalere samsvar",
      "nl": "nauwe match",
      "nn": "snevert samsvar",
      "pl": "dopasowanie pojęcia o węższym znaczeniu",
      "pt-br": "correspondência aproximada",
      "ru": "более узкое соответствие",
      "sl": "ozki pomen",
      "sr": "у ужем смислу",
      "sv": "smal träff",
      "ur": "نیرو میچ",
      "vi": "đối sánh hẹp",
      "zh-hans": "有限匹配"
    },
    "related": [
      {
        "uri": "http://www.w3.org/2004/02/skos/core#broadMatch"
      }
    ],
    "SHORT": "narrow",
    "uri": "http://www.w3.org/2004/02/skos/core#narrowMatch"
  },
  {
    "RELEVANCE": "low",
    "broader": [
      {
        "uri": "http://www.w3.org/2004/02/skos/core#mappingRelation"
      }
    ],
    "definition": {
      "de": [
        "assoziative Verknüpfung unterschiedlicher Bedeutungen"
      ],
      "en": [
        "associative link between meanings"
      ]
    },
    "notation": [
      "~"
    ],
    "prefLabel": {
      "be-tarask": "зьвязаная адпаведнасьць",
      "ca": "parella relacionada",
      "de": "verwandte Bedeutung",
      "en": "related match",
      "eo": "rilata kongruo",
      "fi": "liittyvä käsite",
      "fr": "association",
      "he": "התאמה קשורה",
      "hu": "rokon jelentés",
      "it": "corrispondenza correlata",
      "ja": "関連一致",
      "lv": "saistīta sakritība",
      "mk": "поврзано совпаѓање",
      "ms": "padanan berkaitan",
      "ms-arab": "ڤادنن برکاءيتن",
      "nb": "relatert samsvar",
      "nl": "gerelateerde match",
      "pl": "dopasowanie pojęcia o powiązanym znaczeniu",
      "ru": "ассоциативное соответствие",
      "sl": "povezano ujemanje",
      "tr": "ilişkili benzeşme",
      "uk": "пов’язь",
      "ur": "متعلقہ میچ",
      "vec": "parenteła rełasionada",
      "zh-hans": "关联匹配"
    },
    "SHORT": "related",
    "uri": "http://www.w3.org/2004/02/skos/core#relatedMatch"
  },
  {
    "RELEVANCE": "generic",
    "definition": {
      "de": [
        "unbekannter Bedeutungszusammenhang"
      ],
      "en": [
        "unknown type of link between meanings"
      ]
    },
    "notation": [
      "→"
    ],
    "prefLabel": {
      "ar": "نوع علاقة التطبيق",
      "be": "характэрная адносіна адлюстравання",
      "be-tarask": "характэрная адносіна адлюстраваньня",
      "ca": "relació de mapatge",
      "de": "allgemeine Mapping-Relation",
      "en": "SKOS generic mapping relation",
      "fi": "SKOS-kartoitussuhde",
      "fr": "lien de correspondance SKOS",
      "he": "יחס מיפוי כללי",
      "id": "relasi pemetaan",
      "ja": "SKOS一般マッピング関係",
      "mk": "пресликувачки однос",
      "nb": "SKOS generisk mappingrelasjon",
      "pt-br": "relação genérica de mapeamento",
      "sl": "splošna relacija kartiranja SKOS",
      "sr": "релација мапирања",
      "sv": "mappnings relation",
      "zh": "映射關係",
      "zh-hant": "映射關係"
    },
    "SHORT": "",
    "uri": "http://www.w3.org/2004/02/skos/core#mappingRelation"
  }
]